



































import { Component, Prop, Vue } from 'vue-property-decorator';

import LocalisationRouteCard from '~/components/cards/LocalisationRouteCard.vue';

@Component({
  components: { LocalisationRouteCard },
})
export default class RoutesFeed extends Vue {
  @Prop(Array) routes: [];
  @Prop(Boolean) isLoading: false;
  @Prop(Object) destination: {};

  /* Skeleton length of fake cards to display based on user's window device */
  get skeletonLength () {
    if (process.client) {
      if (window.innerWidth < 1024 && window.innerWidth >= 768) return 3;
      return window.innerWidth < 768 ? 1 : 4;
    }
    return 4;
  }
}
